/**
 * A decorative line chart for the illustrations on this page. Stretches to
 * its box; strokes keep their width however it is scaled.
 */
const W = 300;
const H = 100;
const PAD = 4;

export function Sparkline({ data, color, fill, fillClassName, threshold, className = '' }) {
  const values = threshold == null ? data : [...data, threshold];
  const min = Math.min(...values);
  const span = Math.max(...values) - min || 1; // a flat series draws mid-height, not NaN
  const x = (i) => (data.length === 1 ? W / 2 : (i / (data.length - 1)) * W);
  const y = (v) => PAD + (1 - (v - min) / span) * (H - 2 * PAD);
  const points = data.map((v, i) => `${x(i).toFixed(1)},${y(v).toFixed(1)}`).join(' ');

  return (
    <svg
      viewBox={`0 0 ${W} ${H}`}
      preserveAspectRatio="none"
      aria-hidden="true"
      className={className}
    >
      {/* The area fill is a pale tint meant for a light card; fillClassName
          carries it as currentColor so it can darken with the rest of the
          page instead of staying pinned to its light hex. */}
      {fill && (
        <path
          d={`M0,${H} L${points.replace(/ /g, ' L')} L${W},${H} Z`}
          fill={fillClassName ? 'currentColor' : fill}
          className={fillClassName}
        />
      )}
      {threshold != null && (
        <line
          x1="0" x2={W} y1={y(threshold)} y2={y(threshold)}
          stroke="#ef4444" strokeDasharray="4 4" strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      )}
      <polyline
        points={points}
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}
